import { CallHistory } from '@/types/call-history';

export const mockCallHistory: CallHistory[] = [
  {
    id: 'call-1',
    leadId: '2',
    leadName: 'Michael Tan',
    company: 'Innovative Solutions Pte Ltd',
    callDate: '2024-01-05T10:30:00Z',
    duration: 245,
    outcome: 'interested',
    product: 'pruactive',
    notes: 'Very interested in employee wellness programs. Has budget approved for Q2.',
    nextAction: 'Schedule demo for next week',
    callbackDate: '2024-01-12T14:00:00Z',
    sentiment: 'positive',
    keyPoints: [
      'Current provider contract ending in 3 months',
      'Looking for wellness-focused benefits',
      '200+ employees to cover'
    ]
  },
  {
    id: 'call-2',
    leadId: '3',
    leadName: 'Jennifer Lim',
    company: 'Global Logistics Asia',
    callDate: '2024-01-08T15:45:00Z',
    duration: 180,
    outcome: 'callback',
    product: 'prushield',
    notes: 'In a meeting, requested callback tomorrow afternoon',
    callbackDate: '2024-01-09T14:00:00Z',
    sentiment: 'neutral',
    keyPoints: [
      'Brief conversation',
      'Expressed initial interest',
      'Needs to discuss with board'
    ]
  },
  {
    id: 'call-3',
    leadId: '7',
    leadName: 'Robert Chen',
    company: 'FinanceHub Singapore',
    callDate: '2024-01-07T11:15:00Z',
    duration: 420,
    outcome: 'interested',
    product: 'prushield',
    notes: 'Detailed discussion about coverage options. Wants proposal by end of week.',
    nextAction: 'Send customized proposal',
    sentiment: 'positive',
    keyPoints: [
      'Concerned about rising healthcare costs',
      'Wants comprehensive coverage for executives',
      'Interested in family coverage options'
    ]
  },
  {
    id: 'call-4',
    leadId: '8',
    leadName: 'Amanda Low',
    company: 'Tech Startup Accelerator',
    callDate: '2024-01-06T09:00:00Z',
    duration: 90,
    outcome: 'not_interested',
    product: 'pruactive',
    notes: 'Already has a provider, not looking to switch',
    sentiment: 'negative',
    keyPoints: [
      'Happy with current provider',
      'Not the decision maker',
      'Small team of 15 people'
    ]
  },
  {
    id: 'call-5',
    leadId: '9',
    leadName: 'Daniel Ng',
    company: 'Manufacturing Excellence Ltd',
    callDate: '2024-01-04T16:30:00Z',
    duration: 0,
    outcome: 'no_answer',
    product: 'prushield',
    notes: 'No answer, left voicemail',
    nextAction: 'Try again next week',
    sentiment: 'neutral',
    keyPoints: [
      'Voicemail left',
      'Mentioned Prudential and callback number'
    ]
  },
  {
    id: 'call-6',
    leadId: '10',
    leadName: 'Grace Tan',
    company: 'Retail Chain Asia',
    callDate: '2024-01-03T13:20:00Z',
    duration: 300,
    outcome: 'callback',
    product: 'pruactive',
    notes: 'Interested but needs to review with HR team first',
    callbackDate: '2024-01-15T10:00:00Z',
    sentiment: 'positive',
    keyPoints: [
      'Large workforce of 1000+ employees',
      'Looking for cost-effective solutions',
      'Wants information on group discounts'
    ]
  }
];